import { useGetVisualizarProcessoJudicialHistoricos } from "hooks/processosJudiciais/useGetVisualizarProcessoJudicialHistoricos";
import { useState } from "react";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "types/table/TableColumn";
import RenderRowsVisualizarProcessosJudiciaisHistoricos from "./RenderRowsVisualizarProcessosJudiciaisHistoricos";

interface TabelaVisualizarProcessosJudiciaisHistoricosProps {
  processoId: number | null | undefined;
}

const TabelaVisualizarProcessosJudiciaisHistoricos: React.FC<TabelaVisualizarProcessosJudiciaisHistoricosProps> = (
  props
) => {
  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">("DESC");
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("data");
  const [sortString, setSortString] = useState<string>("data,hora,DESC");
  const [paginaAtual, setPaginaAtual] = useState(1);

  const params = {
    size: 10,
    page: paginaAtual - 1,
    sort: sortString,
  };

  const { data: historicos, isFetching } = useGetVisualizarProcessoJudicialHistoricos(
    props.processoId as number,
    params
  );

  const createColumns = (): TableColumn[] => {
    return [
      {
        id: "data",
        label: "Data",
        isOrdenavel: true,
        width: "140px",
      },
      {
        id: "historico",
        label: "Histórico",
        isOrdenavel: false,
        width: "270px",
      },
      {
        id: "situacao",
        label: "Situação",
        isOrdenavel: false,
        width: "180px",
      },
      {
        id: "acoes",
        label: "",
        isOrdenavel: false,
        width: "50px",
      },
    ];
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao =
      !ordenacaoAscOuDesc || ordenarPorColuna !== idColuna || ordenacaoAscOuDesc === "DESC" ? "ASC" : "DESC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`${idColuna},hora,${novaOrdenacao}`);
  };

  return (
    <Tabela
      id="tabela-processos-judiciais-historicos"
      colunas={createColumns()}
      ordernarPorColuna={ordenarPorColuna}
      ordenacaoAscOuDesc={ordenacaoAscOuDesc}
      ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
      onChangePageFunction={(paginaAtual: number) => setPaginaAtual(paginaAtual)}
      paginaAtual={paginaAtual}
      quantidadeDePaginas={historicos?.totalPages ?? 0}
      renderCheckBox={false}
      isLoading={isFetching}
      quantidadeDeRegistros={historicos?.totalElements ?? 0}
    >
      <RenderRowsVisualizarProcessosJudiciaisHistoricos registros={historicos?.content || []} />
    </Tabela>
  );
};

export default TabelaVisualizarProcessosJudiciaisHistoricos;
